import { baseThemeJson } from "./baseTheme";
import { createMuiTheme } from "@material-ui/core";

export default function(config) {
  return createMuiTheme({
    ...baseThemeJson(config),
    palette: { ...baseThemeJson(config).palette, type: "dark" },
  });
}